<template lang='pug' src='./treatments.pug'></template>

<script>
import Loader from 'components/loader/loader'
import VueTrigger from 'components/block/block-vue-trigger/block-vue-trigger'
import TextBox from 'components/block/block-text-box/block-text-box'
import ImgBox from 'components/block/block-img-box/block-img-box'
import SimpleButton from 'components/block/block-simple-button/block-simple-button'
import FunctionButton from 'components/block/block-function-button/block-function-button'
import ScrollButton from 'components/block/block-scroll-button/block-scroll-button'
import RouterButton from 'components/block/block-router-button/block-router-button'
import HeaderSection from 'components/block/block-header-section/block-header-section'
import TabHeader from 'components/block/block-tab-header/block-tab-header'
import SmileGallery from 'components/custom/custom-smile-gallery/custom-smile-gallery'

export default {
  name: 'treatments',
  computed: {
    props () {
      return this.$store.state.pages.treatments
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    navScrolled () {
      this.$store.dispatch('VIEW_NAV', true)
    },
    notScrolled () {
      this.$store.dispatch('VIEW_NAV', false)
    },
    openModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', {})
    }
  },
  components: {
    Loader,
    VueTrigger,
    TextBox,
    ImgBox,
    SimpleButton,
    FunctionButton,
    RouterButton,
    ScrollButton,
    HeaderSection,
    TabHeader,
    SmileGallery
  }
}
</script>



// WEBPACK FOOTER //
// treatments.vue?b97a23e4